import { useState, useEffect } from 'react';
import translator from '@Components/Utilities/Translator';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import { watchlistOnClick } from '@Components/Utilities/SandhillsWatchlist';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { maxImageCount, gtmEventType, baseCatBlur } from '@Components/Utilities/SandhillsConstants';
import { useRecoilValue } from 'recoil';
import { gtmAlertPushEvent, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import Slider from 'react-slick';

const ListingGridImage = (props) => {

    const [imageLoaded, setImageLoaded] = useState(props.ForceLoadImages || !props.LazyLoad);
    const [updateStatus, setUpdateStatus] = useState(true);
    const [dataAction, setDataAction] = useState('add');
    const [isSavedToWatchlist, setIsSavedToWatchlist] = useState(props.IsWatchlist && !props.IsRecommendedListingListSearch ? props.IsWatchlist : false);
    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const [activeIndex, setActiveIndex] = useState(0);
    const [hasSentImpression, setHasSentImpression] = useState(false);
    const windowSize = useWindowSize();
    let imageList = props.ImageUrl;
    imageList.forEach(p => p.replace('h=220', 'h=350'));
    const useBlur = baseCatBlur.includes(props.BaseCategoryId) || baseCatBlur.includes(props.CategoryID) || (windowSize.width < 1251 && windowSize.width > 550);

    useEffect(() => {
        if (props.UserWatchlist && props.UserWatchlist.length > 0) {
            if ((props.UserWatchlist.filter(c => c.ListingId == props.ListingId || c.Id == props.ListingId).length > 0) && updateStatus) {
                setWatchListAction(true);
            } else if (props.unsaveWatchlist) {
                setIsSavedToWatchlist(false);
                if (props.setSavedToWatchlist) {
                    props.setSavedToWatchlist(false);
                }
                setWatchListAction(false);
            }
        }
    }, [props.UserWatchlist, props.unsaveWatchlist]);

    useEffect(function imageEffect() {
        if (imageLoaded) {
            props.DispatchListings?.({
                type: 'update-listing',
                payload: {
                    Id: props.ListingId,
                    ImagesLoaded: true,
                }
            });
        }
    }, [imageLoaded]);

    const watchlistClick = () => {
        if (props.UserWatchlist.filter(c => c.ListingId == props.ListingId || c.Id == props.ListingId).length < 1 || props.unsaveWatchlist) {
            watchlistOnClick(dataAction, props.ListingId, props.ListingTypes, routes);
            setWatchListAction(dataAction == 'add');
        }

        props.toggleWatchlistExpansion();
    };

    const setWatchListAction = (isSaved) => {
        setIsSavedToWatchlist(isSaved);
        if (props.setSavedToWatchlist) {
            props.setSavedToWatchlist(isSaved);
        }
        setUpdateStatus(false);
        setDataAction(isSaved ? 'delete' : 'add');
    };

    const getWatchlistButton = () => {
        return (
            <span role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); watchlistClick(); } }} aria-label={isSavedToWatchlist ? translator.translate('sandhills.removefromwatchlistwithspace') : translator.translate('sandhills.addtowatchlistwithspace')} className={'image-watchlist ' + (isSavedToWatchlist ? 'watchlist-delet' : 'watchlist-ad')} data-listing-id={props.ListingId} data-action={(isSavedToWatchlist ? 'delete' : 'add')} onClick={watchlistClick}>
                <i className='fas fa-heart'></i>
            </span>
        );
    };

    const changeImage = (image) => {
        var imageObj = new Image();
        imageObj.src = imageList[image];
        if (!imageObj.complete) {
            setImageLoaded(false);
        };
        gtmAlertPushEvent(gtmEventType.imageChange);
        if (!hasSentImpression && image == 1 && props.BaseCategoryId && props.ListingId) {
            // only send the impression once
            setHasSentImpression(true);
            sandhillsRequest({
                url: routes.ImageImpression,
                method: 'post',
                data: {
                    ListingID: props.ListingId,
                    baseCatID: props.BaseCategoryId,
                    HSPub: currentUser.HSTrackingUserID
                }
            })
        }
    };

    const getLeftFlavor = () => {
        let text = '';
        let name = '';

        if (props.IsAT && props.ShowAuctionBranding) {
            if (props.HeaderText.includes(translator.translate('sandhills.featured'))) {
                text = translator.translate('sandhills.featured') + ' ';
            }
            text += translator.translate('sandhills.tradepubwebsite.mvc.onlineauction');

            name = 'at';
        } else if (props.ShowAuctionBranding && props.IsEF) {
            if (props.HeaderText) {
                text = props.HeaderText;
            }
            else {
                text += translator.translate('sandhills.tradepubwebsite.mvc.onsiteauction');
            }

            name = 'ef';
        } else if (props.IsPreAuction) {
            text = translator.translate('sandhills.preauctiontime');
            name = 'pre-at';
        } else if (props.IsFeaturedListing) {
            text = translator.translate('sandhills.tradepubwebsite.mvc.featuredlisting');
            name = 'feat';
        } else if (props.IsPremiumListing) {
            text = translator.translate('sandhills.premiumlisting');
            name = 'prem';
        } else if (props.ShowMediaOverlayBanner) {
            text = props.MediaOverlayBanner
            name = 'equipment-status';
        } else if (props.IsPreTrade) {
            text = translator.translate('sandhills.tradesites.mvc.pretradeoffer');
            name = 'pre-trade';
        } else if (props.IsPreATResult) {
            text = "Pre-AuctionTime Result";
            name = 'pre-atresult';
        }
        if (text && name && name != 'equipment-status' && props.ShowMediaOverlayBanner)
        {
            return (
                <>
                    <span className={'left-flavor ' + name}>{text}</span>
                    <span className='left-flavor-bottom'>{props.MediaOverlayBanner}</span>
                </>
            );
        }
        else if (text && name) {
            return (
                    <span className={'left-flavor ' + name}>{text}</span>           
            );
        }
        return '';
    }

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <i style={{ display: activeIndex == maxImageCount ? 'none' : '' }} className='fas fa-chevron-right arrow arrow-right' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onClick(); } }} aria-label={translator.translate('sandhills.nextimage')} onClick={onClick}></i>
        );
    }

    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <i style={{ display: activeIndex == 0 ? 'none' : '' }} className='fas fa-chevron-left arrow arrow-left' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onClick(); } }} aria-label={translator.translate('sandhills.previmage')} onClick={onClick}></i>
        );
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 525,
        cssEase: "ease-in-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0, 
        arrows: windowSize.isMobile ? false : true,
        swipe: windowSize.isMobile ? true : false,
        draggable: false,
        fade: false,
        appendDots: dots => (
            <div
                style={{
                    backgroundColor: 'rgba(0, 0, 0, .6)',
                    fontSize: '8px',
                    color: '#fff',
                    display: 'flex',
                    gap: '4px',
                    position: 'absolute',
                    bottom: '8px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    left: '0',
                    right: '0',
                    width: 'fit-content',
                    margin: 'auto',
                    padding: '3px 4px',
                    borderRadius: '50px'
                }}
            >
                <ul style={{ margin: '0px' }}>{dots}</ul>
            </div>
        ),
        customPaging: i => (
            <div>
                <i tabIndex='0' className={activeIndex == i ? 'fas fa-circle' : "far fa-circle"}></i>
            </div>
        ),
        beforeChange: (current, next) => {
            if (current != next) {
                setActiveIndex(next);
            }
        },
        afterChange: (current) => {
            changeImage(current);
            setActiveIndex(current); 
        },
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    const blurBackgroundStyle = {
        position: 'absolute',
        height: '220px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        filter: 'blur(5px)',
        width: '100%',
        objectFit: 'cover',
        opacity: '.25'
    };

    const blurImageStyle = {
        position: 'absolute',
        height: '200px',
    };

    const blurMaxImageStyle = {
        position: 'absolute',
        height: '220px',
        opacity: '0.4'
    };

    const maxImageStyle = {
        height: '200px',
        opacity: '0.4'
    };
    const imageStyle = {
        height: '200px',
    };


    return (
        <>
            <div className='listing-image'>
                    <div className={'listing-image-container' + ' ' + (useBlur ? 'listing-image-container-height-blur' : 'listing-image-container-height')} style={{ 'height': useBlur ? '220px' : '200px', maxHeight: useBlur ? '220px' : '200px' }}>
                        <span className='top-banner'>
                            {getLeftFlavor()}
                            <span className='right-flavor'>
                                {props.ShowWatchlist && getWatchlistButton()}
                            </span>
                        </span>
                        <ConditionalWrapper condition={props.DetailUrl} wrapper={children =>
                        <a href={props.DetailUrl} className={props.NoImage ? "no-image" : "" } target={props.LinkTarget} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + " " + props.ListingTitle + " - " + props.ListingId}>
                                {children}
                        </a>}>
                        {props.ImageUrl.length > 1 ?
                            <Slider {...settings}>
                                {props.ImageUrl.map((image, index) => {
                                    return (
                                        <div key={props.ListingId + ' - ' + index}>
                                            {useBlur ?
                                                <div style={{ position: 'relative', height: '220px' }}>
                                                    {index == maxImageCount ?
                                                        <>
                                                            <span className='contain'><a href={props.DetailUrl} tabIndex={activeIndex != maxImageCount ? '-1' : 0 } target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.tradepubwebsite.mvc.viewall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a></span>
                                                            <img style={blurMaxImageStyle} loading={!props.LazyLoad && index == 0 ? '' : 'lazy'} fetchpriority={!props.LazyLoad && index == 0 ? 'high' : 'low'} className={'listing-main-image'} src={image} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID + ' - ' + index} />
                                                        </> :
                                                        <>
                                                            <span>
                                                                <img style={blurBackgroundStyle} loading={!props.LazyLoad && index == 0 ? '' : 'lazy'} fetchpriority={!props.LazyLoad && index == 0 ? 'high' : 'low'} src={image} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID + ' - ' + index} /> 
                                                            </span>
                                                            <span>
                                                                <img style={blurImageStyle} loading={!props.LazyLoad && index == 0 ? '' : 'lazy'} fetchpriority={!props.LazyLoad && index == 0 ? 'high' : 'low'} className={'listing-main-image'} src={image} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID + ' - ' + index} /> 
                                                            </span>
                                                        </>

                                                    }
                                                </div> :
                                                (index == maxImageCount ?
                                                    <>
                                                        <span className='contain' style={{maxWidth: '100%'}}><a href={props.DetailUrl} tabIndex={activeIndex != maxImageCount ? '-1' : 0} target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.tradepubwebsite.mvc.viewall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a></span>
                                                        <img style={maxImageStyle} loading={!props.LazyLoad && index == 0 ? '' : 'lazy'} fetchpriority={!props.LazyLoad && index == 0 ? 'high' : 'low'} className={'listing-main-img'} src={image} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID + ' - ' + index} />
                                                    </> :
                                                    <span>
                                                        <img style={imageStyle} loading={!props.LazyLoad && index == 0 ? '' : 'lazy'} fetchpriority={!props.LazyLoad && index == 0 ? 'high' : 'low'} className={'listing-main-img'} src={image} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID + ' - ' + index} />
                                                    </span>
                                                )}
                                        </div>)
                                })}
                            </Slider> :
                            
                            (useBlur && !props.NoImage ?
                                <>
                                    <span>
                                        <img style={blurBackgroundStyle} loading={props.LazyLoad ? 'lazy' : '' } fetchpriority={props.LazyLoad ? 'low' : 'high'} src={imageList[activeIndex]} alt={props.AltText ? props.AltText : props.ListingTitle + ' - background - ' + props.ListingID} />
                                    </span>
                                    <span>
                                        <img loading={props.LazyLoad ? 'lazy' : ''} fetchpriority={props.LazyLoad ? 'low' : 'high'} style={blurImageStyle} className={'listing-main-image'} src={imageList[activeIndex]} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID} />
                                    </span>
                                </>
                                :
                                <span>
                                    <img loading={props.LazyLoad ? 'lazy' : ''} fetchpriority={props.LazyLoad ? 'low' : 'high'} className={useBlur ? 'listing-main-image' : 'listing-main-img'} src={imageList[activeIndex]} alt={props.AltText ? props.AltText : props.ListingTitle + ' - ' + props.ListingID} />
                                </span>
                                )
                            }
                        </ConditionalWrapper>
                    </div>
            </div>
        </>
    );
};

export default ListingGridImage;